module.exports = __webpack_public_path__ + "img/vpc.221d24a.svg";